import type { FaireProductEntity } from "../../entity_types/product";

export const p_nqyd962k4j: FaireProductEntity = {
  token: "p_nqyd962k4j",
  type: "product",
  name: "Kauai Surfer Bracelet, Adjustable Beaded Bracelet",
  brandName: "Pineapple Island",
  imageUrl:
    "https://cdn.faire.com/fastly/c9f62796006716109f9c0ae876900ef5c8e27803707a83d1df167edf6d2e442d.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0193d1d2c59385c27107b0c57a7aed1727f42362d6a757e5c0b72e25554aa2b7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
